import gql from 'graphql-tag'

export const LOGGED_IN_USER = gql `
  query {
    me {
      id
      name
      email
    }
  }
`
export const GET_LAST_POSTS_MURO = gql `
query muros(
  $id_empresa: String!
  $id_usuario: String!
){
  muros(id_empresa: $id_empresa, id_usuario: $id_usuario) {
    id_muro
    texto
    imagen_muro
    video_muro
    fecha_creacion
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
    }
    likes {
      id_like
      id_usuario_fk
    }
    confirm_like {
      id_like
    }
    likes_global {
      id_like
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
    }
    confirm_like_global {
      id_like
      fecha_creacion
      is_team
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
    }
    comentarios {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
      menciones {
        id_mencion
      }
      likes {
        id_like
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
          cargo {
            nombre_cargo
          }
        }
      }
    }
    
  }
}`;
export const GET_PAGES_MURO = gql `
query TotalPaginasPublicacionesMuro(
  $id_empresa: String!
  $id_usuario: String!
  $plataforma: String!
  $fecha_inicio: String!
  $fecha_final: String!
  $nombre: String!
  $limite: String!
  ){
  
  TotalPaginasPublicacionesMuro(
    id_empresa:$id_empresa,
    id_usuario:$id_usuario,
    plataforma:$plataforma,
    fecha_inicio:$fecha_inicio,
    fecha_final:$fecha_final,
    nombre:$nombre,
    limite:$limite
  ) {
    pagina
    muros
  }
}`;

export const GET_MURO_BY_ID = gql `
query PublicacionesMuroPaginas(
    $id_empresa: String!
    $id_muro : [String!]
    $plataforma : String!
){
  
  PublicacionesMuroPaginas(
    id_empresa: $id_empresa,
    id_muro: $id_muro,
    plataforma: $plataforma 
  ) {
    id_muro
    texto
    imagen_muro
    video_muro
    fecha_creacion
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
    }
    likes {
      id_like
      id_usuario_fk
    }
    confirm_like {
      id_like
    }
    likes_global {
      id_like
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
    }
    confirm_like_global {
      id_like
      fecha_creacion
      is_team
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
    }
    comentarios {
      id_comentario
      texto
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
      menciones {
        id_mencion
      }
      likes {
        id_like
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
          cargo {
            nombre_cargo
          }
        }
      }
    }
    
  }
}`;



export const GET_CUMPLEANIOS_DEL_DIA = gql `
  query birthdaysToday(
    $id_empresa: String!
  ){
    birthdaysToday(id_empresa: $id_empresa) {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      telefono_movil
      correo
      anexo
      cargo {
        nombre_cargo
      }
      gerencia {
        nombre_gerencia
      }    
      sucursal {
        nombre_sucursal
      }
    }
  }
`

export const TODAS_NOTICIAS = gql `
  {
    noticias(
      id_usuario: ""
      id_empresa: "1"
      id_categoria: ""
      especial_categoria: ""
    ) {
      id_noticia
      titulo_noticia
      url_imagen_principal
      fecha_noticia
      categoria {
        id_categoria
      }
      likes {
        id_like
        id_usuario_fk {
          id_usuario
        }
      }
      comentarios {
        id_comentario
      }
    }
  }
`

export const paginadorNoticiasApp = gql `
  query {
    paginadorNoticiasApp(
      id_usuario: ""
      id_empresa: "1"
      id_categoria: ""
      limite: "16"
    ) {
      pagina
      noticias
    }
  }
`
export const GET_NOTICIAS = gql `
query bannerNoticias(
  $id_empresa: String!
  $id_usuario: String!
  $limite: String!
)
{
  bannerNoticias(id_empresa: $id_empresa, id_usuario: $id_usuario, limite: $limite) 
  {
    id_noticia
    titulo_noticia
    url_imagen_principal
    fecha_noticia,
    confirm_visto,
    vistos {
      id_usuario_fk
    }
  }
}`;

export const GET_LAST_GALERIAS = gql `
query LastGaleria(
  $id_empresa: String!
  $id_usuario: String!
) {
  LastGaleria(id_empresa: $id_empresa, id_usuario: $id_usuario) {
    id_galeria
    titulo_galeria
    fecha_galeria
    imagenes {
      id_imagen
      url_imagen_original
      url_imagen_thumb
      likes {
        id_like
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
          cargo {
            nombre_cargo
          }
        }
      }
      confirm_like {
        id_like
      }
    }
    likes {
      id_like
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
    }
    confirm_like {
      id_like
    }
  }
}`;

export const GET_LAST_VIDEO = gql `
query videoUltimo(
  $id_empresa: String!
  $id_usuario: String!
){
  videoUltimo(id_empresa: $id_empresa, id_usuario: $id_usuario)
  {
    id_video
    titulo_video
    descripcion_video
    url_imagen
    url_video
    fecha_video
    likes {
      id_like
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          nombre_cargo
        }
      }
    }
    comentarios {
      id_comentario
    }
    confirm_like {
      id_like
    }
  }
}`;

export const GET_NUEVOS_INGRESOS = gql `
query LastNewIngresos(
  $id_empresa: String!
  $limit: String!
)
{
  LastNewIngresos(id_empresa: $id_empresa, limit: $limit)
  {
    id_usuario
    primer_nombre
    apellido_paterno
    imagen_perfil
    cargo {
      nombre_cargo
    }
    sucursal {
      nombre_sucursal
    }
  }
}`;

export const GET_LAST_MOVIMIENTO = gql `
query LastNewMovimientos(
  $id_empresa: String!
  $limit: String!
){
  LastNewMovimientos(id_empresa: $id_empresa, limit: $limit)
  {
    id_movimiento
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
    }
    cargo_antiguo {
      nombre_cargo
    }
    cargo_nuevo {
      nombre_cargo
    }
  }
}`;

export const GET_LAST_RECONOCIMIENTO = gql `
query lastReconocimientos(
  $id_empresa: String!
  $id_usuario: String!
  $limit: String!
){
  lastReconocimientos(id_empresa: $id_empresa, id_usuario: $id_usuario, limit: $limit)
  {
    id_reconocimiento
    fecha_creacion
    reconocidos {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo { nombre_cargo }
    }
    reconocedor {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo { nombre_cargo }
    }
    valor_comportamiento {
      valor {
        nombre_valor
      }
    }
  }
}`;

/*-------- Noticinas ----- */
export const GET_PAGINACION_NOTICIAS = gql `
query paginadorNoticiasIntranet(
  $nombre: String!
  $id_usuario: String!
  $id_empresa: String!
  $id_categoria: String!
  $recien_visto: String!
  $limite: String!
  ) 
  {
  paginadorNoticiasIntranet(
    id_usuario: $id_usuario,
    id_empresa: $id_empresa,
    id_categoria: $id_categoria,
    nombre: $nombre,
    reciente_visto: $recien_visto,
    limite: $limite
  ) {
    pagina
    noticias
  }
}`;

export const GET_NOTICIAS_CON_PAGINACION = gql `
query noticiasPaginadas(
  $id_noticias: [String]!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  noticiasPaginadas(
    id_usuario: $id_usuario,
    id_empresa: $id_empresa,
    id_noticia: $id_noticias
  ) {
    id_noticia
    titulo_noticia
    url_imagen_principal
    fecha_noticia
    likes {
      id_like
    }
    comentarios {
      id_comentario
    }
    comentarios_compartidos{
      id_comentario
    }
    confirm_like {
      id_like
    }
    confirm_visto
    vistos {
      id_visto
      id_usuario_fk
    }
  }
}`;
export const GET_NOTICIA = gql `
query noticia(
  $id_noticia: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
    noticia(id_usuario: $id_usuario, id_empresa: $id_empresa, id_noticia: $id_noticia) 
    {
      id_noticia
      titulo_noticia
      url_imagen_principal
      fecha_noticia
      tipo_noticia {
        id_tipo
        nombre_tipo
      }
      likes {
        id_like
      }
      confirm_visto
      confirm_like {
        id_like
      }
      contenido 
      {
        id_contenido
        texto
        url_imagen
        url_video
        url_documento
        tipo_contenido {
          id_tipo_contenido
          nombre_tipo_contenido
        }
      }
      comentarios 
      {
        id_comentario
        texto
        fecha_creacion
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
        }
        respuestas_comentarios 
        {
          id_comentario
          texto
          fecha_creacion
          usuario {
            id_usuario
            primer_nombre
            apellido_paterno
            imagen_perfil
          }
          likes {
            id_like
            usuario {
              id_usuario
            }
          }
        }
        likes {
          id_like
          usuario {
            id_usuario
          }
        }
      }
      comentarios_compartidos 
      {
        id_comentario
        texto
        fecha_creacion
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
        }
        respuestas_comentarios 
        {
          id_comentario
          texto
          fecha_creacion
          usuario {
            id_usuario
            primer_nombre
            apellido_paterno
            imagen_perfil
          }
          likes {
            id_like
            usuario {
              id_usuario
            }
          }
        }
        likes {
          id_like
          usuario {
            id_usuario
          }
        }
      }
  }
}`;
/*-------- Noticias ------*/

/*-------- Menu ------*/
export const GET_MODULOS_APP = gql`
query modulosApp(
  $id_empresa: String!
  $id_usuario: String!
  $id_privilegio: String!
  ) 
  {
    modulosApp(
    id_usuario: $id_usuario,
    id_empresa: $id_empresa,
    id_privilegio: $id_privilegio
  ) 
  {
    nombre_modulo
    url_menu_activo
    url_menu_inactivo
    ruta_web
    imagen_url
    posicion_intranet
    moduloGeneral{
      id_modulo,
      nombre_modulo,
      descripcion_modulo,
      id_app,
      id_admin,
      is_web
    }
  }
}`;

export const GET_MODULOS_INTRANET = gql `
query modulosIntranet(
  $id_empresa: String!
  $id_usuario: String!
  $id_privilegio: String!
  ) 
  {
    modulosIntranet(
    id_usuario: $id_usuario,
    id_empresa: $id_empresa,
    id_privilegio: $id_privilegio
  ){
    descripcion_modulo
    destacado
    id_detalle
    id_estado_fk
    imagen_url
    moduloGeneral {
      id_modulo
      nombre_modulo
      descripcion_modulo
      id_app
      id_admin
      is_web
      tipo_check
    }
    nombre_modulo
    posicion_intranet
    posicion_pantalla
    ruta_web
    url_menu_activo
    url_menu_inactivo
  }
}`;

/*-------- Menu ------*/

/*-------- Galerias ------*/
export const GET_YEAR_GALERIAS = gql `
query yearGaleria(
  $id_empresa: String! 
  $id_usuario: String!
)
{
  yearGaleria(id_empresa: $id_empresa, id_usuario: $id_usuario) {
    year
  }
}`;

export const GET_MONTH_FOR_GALERIAS = gql `
query monthGaleria(
  $year: String!
  $id_empresa: String!
  $id_usuario: String!
  ) 
  {
  monthGaleria(id_empresa: $id_empresa, year: $year, id_usuario: $id_usuario) 
  {
    month
    cantidad_albumes
  }
}`;

export const GET_GALERIA_MES_YEAR = gql `
query galeriasMesYear(
  $year: String! 
  $month: String!
  $id_usuario: String!
  $id_empresa: String!
  ) 
  {
  galeriasMesYear(id_empresa: $id_empresa, year: $year, month: $month, id_usuario: $id_usuario) 
  {
    id_galeria
    titulo_galeria
    fecha_galeria
    imagenes {
      id_imagen
      url_imagen_thumb
      url_imagen_original
      likes {
        id_like
        usuario {
          id_usuario
        }
      }
    }
  }
}`;
export const GET_GALERIA = gql `
query galeria(
  $id_galeria: String!
  $id_empresa: String!
  $id_usuario: String!
  $plataforma: String!
  ) 
  {
  galeria(id_empresa: $id_empresa, id_galeria: $id_galeria, id_usuario: $id_usuario, plataforma: $plataforma) 
  {
    id_galeria
    titulo_galeria
    fecha_galeria
    total_likes_admin
  }
}`;

export const GET_PAGINAS_IMAGENES_GALERIAS = gql `
query PaginasImagenesGaleria(
  $id_empresa: String!
  $id_galeria: String!
  $limite: String!
  )
{
  PaginasImagenesGaleria(id_empresa: $id_empresa, id_galeria: $id_galeria, limite: $limite)
  {
    pagina
    galerias
  }
}`;

export const GET_IMAGENES_GALERIA = gql `
query ListImagenes(
  $id_empresa: String!
  $id_imagen: [String]!
  $id_usuario: String!
)
{
  ListImagenes(id_empresa: $id_empresa, id_imagen: $id_imagen, id_usuario: $id_usuario)
  {
    id_imagen
    url_imagen_original
    likes 
    {
      id_like
      usuario 
      {
        id_usuario
      }
    }
    confirm_like
    {
      id_like
    }
  }
}
`
    /*-------- Galerias ------*/

/*-------- Video ------*/
export const GET_CATEROGIA_VIDEO = gql `
query categoriasVideos(
  $id_empresa: String! 
  $plataforma: String!
  )
  {
  categoriasVideos(id_empresa: $id_empresa, plataforma: $plataforma) {
    id_categoria
    nombre_categoria
  }
}`;

export const GET_PAGINACION_VIDEO = gql `
query paginacionTotalVideos(
  $id_usuario: String!
  $id_empresa: String!
  $id_categoria: String!
  $nombre: String!
  $limite: String!
  $reciente_visto: String!
  $dispositivo: String!
  ) 
  {
  paginacionTotalVideos(id_usuario: $id_usuario, id_empresa: $id_empresa, id_categoria: $id_categoria, nombre: $nombre, limite: $limite, reciente_visto: $reciente_visto, dispositivo: $dispositivo) 
  {
    pagina
    videos
  }
}`;

export const GET_VIDEOS_CON_PAGINACION = gql `
query videosPlataforma(
  $id_empresa: String!
  $ids: [String]!
  $id_usuario: String!
  ) {
  videosPlataforma(id_empresa: $id_empresa, id_video: $ids, id_usuario: $id_usuario) {
    id_video
    titulo_video
    fecha_video
    url_imagen
    categoria {
      id_categoria
      nombre_categoria
    }
    likes {
      id_like
    }
    comentarios {
      id_comentario
    }
    confirm_like {
      id_like
    }
    vistos {
      id_visto
      usuario {
        id_usuario
      }
    }
  }
}`;

export const GET_VIDEO = gql `
query video(
  $id_empresa: String!
  $id_video: String!
  $id_usuario: String!
  ) 
  {
  video(id_empresa: $id_empresa, id_video: $id_video, id_usuario: $id_usuario) 
  {
    id_video
    titulo_video
    descripcion_video
    url_video
    fecha_video
    likes {
      id_like
      usuario {
        id_usuario
      }
    }
    confirm_like{
      id_like
    }
    comentarios {
      id_comentario
      texto
      fecha_creacion
      likes {
        id_like
        usuario {
          id_usuario
        }
      }
      respuestas_comentarios {
        id_comentario
        texto
        fecha_creacion
        usuario {
          id_usuario
          primer_nombre
          apellido_paterno
          imagen_perfil
        }
        likes {
          id_like
          usuario {
            id_usuario
          }
        }
      }
      usuario {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
      }
    }
  }
}`;
/*-------- Video ------*/

/*-------- Reconoce ------*/
export const GET_USUARIO = gql `
query usuario(
  $id_empresa: String! 
  $id_usuario: String!
  )
  {
    usuario(id_empresa: $id_empresa, id_usuario: $id_usuario) 
    {
      id_usuario
      primer_nombre
      apellido_paterno
      apellido_materno
      imagen_perfil
      correo
      telefono_movil
      cargo {
        nombre_cargo
      }
      sucursal {
        nombre_sucursal
      }
      gerencia {
        id_gerencia,
        nombre_gerencia
      }
      turno {
        id_turno,
        nombre_turno
      }
  }
}`;

export const GET_USUARIOS_FOR_RECONOCER = gql`
query usuarios(
  $id_empresa: String! 
  $id_usuario: String!
  )
  {
    usuarios(id_empresa: $id_empresa, id_usuario: $id_usuario) 
    {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      correo
      telefono_movil
      cargo {
        nombre_cargo
      }
      sucursal {
        nombre_sucursal
      }
  }
}`;


export const GET_RECONOCIMIENTOS_PAGINA = gql`
query listReconocimientos(
  $tipo_reconocimiento: Int!
  $id_valor: Int
  $pagina: Int!
  $nombre_usuario: String
) {
  listReconocimientos(
    nombre_usuario: $nombre_usuario
    tipo_reconocimiento: $tipo_reconocimiento
    id_valor: $id_valor
    pagina: $pagina
  ) {
    previous_page
    next_page
    count
    total_pages
    data {
      id_reconocimiento
      url_imagen
      comentario_reconocimiento
      fecha_creacion
      visto
      nombre_grupo
      tipo_reconocimiento {
        id_tipo
        nombre_tipo
        descripcion
        id_estado_fk
      }
      reconocidos { 
        id_usuario 
        primer_nombre 
        apellido_paterno 
        cargo { nombre_cargo } 
        imagen_perfil
      }
      reconocedor { 
        id_usuario 
        primer_nombre 
        apellido_paterno 
        cargo { nombre_cargo } 
        imagen_perfil
      }
      superiores { 
         id_usuario 
        primer_nombre 
        apellido_paterno 
        cargo { nombre_cargo } 
        imagen_perfil
      }
      likes {
        id_like
        fecha_creacion
      #   id_usuario_fk
      #   id_reconocimiento_fk
      #   usuarios { imagen_perfil }
      }
      confirm_like {
        id_like
        fecha_creacion
      #   id_usuario_fk
      #   id_reconocimiento_fk
      #   # usuarios: Usuario
      }
      valor_comportamiento {
        id_valor_comportamiento
        valor {
          id_valor
          nombre_valor
          color
          id_estado_fk
        }
        comportamiento {
          id_comportamiento
          nombre_comportamiento
          id_estado_fk
        }  
      }
      relacion {
        id_relacion
        nombre_relacion
        id_estado_fk
      }
    }
  }
}`;

export const GET_VALORES_RECONOCIMIENTOS = gql `
query valoresReconocimientos {
  valoresReconocimientos {
    id_valor
    nombre_valor
    color
  }
}`;

/* No se usa */
export const GET_TOTAL_RECONOCIMIENTOS = gql `
query totalReconocimientosUsuarios(
  $id_empresa: String!
  $id_usuario: String!
  $tipo_reconocimiento: Int!
  ) {
  totalReconocimientosUsuarios(
    id_empresa: $id_empresa 
    id_usuario: $id_usuario
    tipo_reconocimiento:  $tipo_reconocimiento
  ) {
    total
  }
}`;

export const GET_TOTAL_RECONOCIMIENTOS_POR_VALOR = gql `
query totalReconocimientoPorValor($tipo_reconocimiento: Int!) {
  totalReconocimientoPorValor(tipo_reconocimiento: $tipo_reconocimiento) {
    color
    id_valor
    nombre_valor
    count
  }
}
`;

export const GET_RELACIONES_RECONOCIMIENTO = gql `
query relacionesReconocimientos(
  $id_empresa: String!
  ) 
  {
    relacionesReconocimientos(id_empresa: $id_empresa) 
  {
    id_relacion
    nombre_relacion
  }
}`;
/*-------- Reconoce ------*/
/*-------- Cultura ------*/
export const GET_CULTURA = gql `
query culturas(
  $id_empresa: String! 
  )
  {
    culturas(id_empresa: $id_empresa) 
    {
      id_cultura
      descripcion {
        id_descripcion
        titulo
        texto
        url_documento
        color_elemento
      }
      valores 
      {
        id_valor
        nombre
        descripcion
        color
        imagen_url
        orden
      }
    }  
}`;

export const VALORES = gql `
  query {
    culturas(id_empresa: "1") {
      id_cultura
      valores 
      {
        id_valor
        nombre
        descripcion
        color
        imagen_url
        orden
      }
    }
  }`;
/*-------- Cultura ------*/
/*-------- Organigrama ------*/
export const GET_DOCUMENTOS_ORGANIGRAMA = gql `
query AllDocumentos(
    $id_empresa: String!
    $id_usuario: String!
    $id_categoria: String!
    $id_modulo: String!
    $plataforma: String! 
    ){
    AllDocumentos(
      id_empresa: $id_empresa,
      id_usuario: $id_usuario,
      id_categoria: $id_categoria,
      id_modulo: $id_modulo,
      plataforma: $plataforma
    ) {
      id_categoria
      nombre
      documentos {
        id_documento
        nombre
        url_documento
        fecha_creacion
      }
    }
}`;

export const GET_EMPRESAS = gql `
query empresaId(
  $id_empresa: String!
  ){
    empresaId(id_empresa: $id_empresa)
    {
      id_empresa
      nombre_empresa
    }
}`;
/*-------- Organigrama ------*/

/*-------- Biblioteca/Seguridad ------*/
export const GET_DOCUMENTOS_BIBLIOTECA = gql `
query DocumentosBibliotecaPaginacion(
  $id_empresa: String!
  $id_usuario: String!
  $id_categoria: String!
  $id_modulo: String!
  $plataforma: String!
  $nombre: String!
  $last_id: String!
  $limit: String!
  ) 
  {
  DocumentosBibliotecaPaginacion(
    id_empresa: $id_empresa,
    id_usuario: $id_usuario,
    id_categoria: $id_categoria,
    id_modulo: $id_modulo,
    plataforma: $plataforma,
    nombre: $nombre,
    last_id: $last_id,
    limit: $limit
  ) {
    id_documento
    nombre
    url_documento
    fecha_creacion
    categoria {
      id_categoria
      nombre
    }
  }
}`;

export const GET_CATEGORIA_DOCUMENTO = gql `
query CategoriasDocumentos(
  $id_empresa: String!
  $id_modulo: String!
  ){
    CategoriasDocumentos(id_empresa: $id_empresa, id_modulo: $id_modulo) {
      id_categoria
      nombre
    }
}`;
/*-------- Biblioteca/Seguridad ------*/
//birthdaysDates
/*-------- Cumpleaños ------*/
export const GET_BIRTHDATE = gql `
query birthdaysDates(
  $id_empresa: String!
  $month: String! 
  $day: String!
  ) {
  birthdaysDates(id_empresa: $id_empresa, month: $month, day: $day) 
  {
    id_usuario
    primer_nombre
    apellido_paterno
    imagen_perfil
    fecha_nacimiento
    cargo {
      nombre_cargo
    }
    sucursal {
      nombre_sucursal
    }
  }
}`;
export const GET_BIRTHDAY = gql `
query birthdaysDays(
  $id_empresa: String!
  $month: String!
  ) 
  {
    birthdaysDays(id_empresa: $id_empresa, month: $month) {
      day
    }
  }`;
/*-------- Cumpleaños ------*/

/*-------- Transporte ------*/
export const GET_PLANIFICACIONES = gql `
query GetPlanificacionesApp(
  $id_empresa: String!
  ) {
    GetPlanificacionesApp(id_empresa: $id_empresa) 
    {
      id_planificacion
      nombre_planificacion
      fecha_inicio_inscripcion
      fecha_fin_inscripcion
      fecha_viaje
      hora_viaje
    }
}`;

export const GET_TRAMOS_APP_VUELTA = gql`
query GetTramosAppVuelta(
  $idEmpresa: String!
  $idPlanificacion: String!
  $fechaViaje: String!
  $idTipoTransporte: String!
  $idTramoIda: String!
) {
  GetTramosAppVuelta(
    id_empresa: $idEmpresa
    id_planificacion: $idPlanificacion
    fecha_viaje: $fechaViaje
    id_tipo_transporte: $idTipoTransporte
    id_tramo_ida: $idTramoIda
  ) {
    id_tramo
    codigo
    hora_viaje
    fecha_viaje
    transporte_lista_destino {
      nombre_origen
      nombre_destino
    }
    transporte_planificacion{
      id_planificacion
      nombre_planificacion
      tranpsorte_planificacion_detalle{
        id_detalle
        fecha_inicio_ejecucion
        fecha_final_ejecucion
      }
    }
    transporte_ida_vuelta {
      id_ida_vuelta
      nombre_idea_vuelta
    }
    asientos {
      id_asiento
      nombre_asiento
      disponible
    }
    
  }
}
`;

export const GET_PLANIFICACION_ID = gql `
query getOnePlanificacionID(
  $id_planificacion: String!
  $id_empresa: String!
  ) {
  getOnePlanificacionID(id_empresa: $id_empresa, id_planificacion: $id_planificacion) 
  {
    id_planificacion
    nombre_planificacion
    tranpsorte_planificacion_detalle {
      fecha_inicio_ejecucion
      fecha_final_ejecucion
    }
  }
}`;
export const GET_TURNOS = gql `
query turnos(
  $id_empresa: String!
  ) {
    turnos(id_empresa: $id_empresa) {
      id_turno
      nombre_turno
    }
}`;

export const GET_TEAMS = gql `
query teams(
  $id_empresa: String!
  ) {
    teams(id_empresa: $id_empresa) 
    {
      id_team
      nombre_team
    }
}`;

export const GET_TIPO_TRANSPORTE = gql `
query tipoTransporte{
  tipoTransporte 
    {
      id_tipo
      nombre_transporte
    }
}`;

export const GET_TIPO_TRANSPORTE_EMPRESA = gql `
query tipoTransporteEmpresa(
  $id_empresa: String!
  $id_planificacion: String!
  $fecha_viaje: String!
){
  tipoTransporteEmpresa(
    id_empresa: $id_empresa,
    id_planificacion: $id_planificacion,
    fecha_viaje: $fecha_viaje,
  ) {
    id_tipo
    nombre_transporte
    total_tramos
  }
}
`;



export const GET_TRAMOS = gql `
query GetTramosApp(
  $id_empresa: String!
  $id_planificacion: String!
  $fecha_viaje: String!
  $id_tipo_transporte: String!
  $is_principal: String!
  $id_tramo_padre: String!
) {
  GetTramosApp(
    id_empresa: $id_empresa,
    id_planificacion: $id_planificacion,
    fecha_viaje: $fecha_viaje,
    id_tipo_transporte: $id_tipo_transporte,
    is_principal: $is_principal,
    id_tramo_padre: $id_tramo_padre
  ) 
  {
    id_tramo
    codigo
    hora_viaje
    fecha_viaje
    transporte_lista_destino {
      nombre_origen
      nombre_destino
      
    }
    transporte_ida_vuelta {
      id_ida_vuelta
      nombre_idea_vuelta
    }
    asientos {
      id_asiento
      nombre_asiento
      disponible
    }
  }
}
`

export const GET_TIPO_IDA_VUELTA = gql `
query tipoIdaVuelta{
  tipoIdaVuelta 
  {
    id_ida_vuelta
    nombre_idea_vuelta
  }
}
`

export const GET_SOLICITUDES_USUARIO = gql `
query FindSolicitudesRecientesUsuario($id_empresa: String!, $id_usuario: String!) {
  FindSolicitudesRecientesUsuario(id_empresa: $id_empresa, id_usuario: $id_usuario) {
    id_solicitud
    fecha_creacion
    error
    guardado
    ida_vuelta
    usuario {
      id_usuario
      primer_nombre
      apellido_paterno
      apellido_materno
      imagen_perfil
      turno {
        id_turno
        nombre_turno
      }
      team {
        id_team
        nombre_team
      }
      rut_usuario
      dv_usuario
      cargo {
        nombre_cargo
      }
      gerencia {
        nombre_gerencia
      }
      telefono_movil
      correo
    }
    transporte_tramo {
      id_tramo
      codigo
      codigo_asientos
      fecha_viaje
      hora_viaje
      transporte_lista_destino {
        id_destino
        nombre_origen
        nombre_destino
        transporte_tipo_medio {
          id_medio
          nombre_medio
          cantidad_asiento
          transporte_tipo {
            id_tipo
            nombre_transporte
          }
        }
      }
      transporte_planificacion {
        id_planificacion
        nombre_planificacion
      }
    }
    transporte_asiento {
      id_asiento
      nombre_asiento
    }
    transporte_tramo_conexion {
      id_tramo
      codigo
      codigo_asientos
      transporte_lista_destino {
        id_destino
        nombre_origen
        nombre_destino
        transporte_tipo_medio {
          id_medio
          cantidad_asiento
        }
      }
      asientos {
        id_asiento
        nombre_asiento
        disponible
      }
    }
    transporte_asiento_conexion {
      id_asiento
      nombre_asiento
    }
  }
}
`;
/*-------- Transporte ------*/

/*-------- Encuestas ------*/
export const GET_ENCUESTAS_PAGINAS = gql `
query paginacionTotalEncuestas(
  $id_empresa: String!
  $id_usuario: String!
  $limite: String!
  ) 
  {
    paginacionTotalEncuestas(id_usuario: $id_usuario, id_empresa: $id_empresa, limite: $limite) 
  {
    pagina
    encuestas
  }
}`;

export const GET_ENCUESTAS_PAGINADAS = gql `
query listEncuestasActivas(
  $id_empresa: String!
  $id_encuesta: [String]!
  $id_usuario: String!
  ) {
  listEncuestasActivas(
    id_empresa: $id_empresa
    id_encuesta: $id_encuesta
    id_usuario: $id_usuario
  ) {
    id_encuesta
    nombre_encuesta
    descripcion
    tipo_encuesta{
      id_tipo_encuesta
      nombre_tipo_encuesta
    }
    url_encuesta
  }
}
`
export const GET_ENCUESTA_ID = gql `
query encuestaIdAdmin(
  $id_empresa: String!
  $id_encuesta: String!
  ) {
  encuestaIdAdmin(id_empresa: $id_empresa, id_encuesta: $id_encuesta) 
  {
    id_encuesta
    nombre_encuesta
    descripcion
    tipo_encuesta {
      id_tipo_encuesta
      nombre_tipo_encuesta
    }
    preguntas {
      id_pregunta
      texto_pregunta
      editable
      is_star
      is_points
      tipo_pregunta {
        id_pregunta_tipo
        nombre_pregunta_tipo
      }
      alternativas {
        id_alternativa
        texto_alternativa
      }
    }
  }
}`;
/*-------- Encuestas ------*/
/*-------- Folovid ------*/
export const GET_ESTADISTICA_FOLOVID = gql `
query EstadisticasApp(
  $id_empresa: String!
){
  EstadisticasApp(id_empresa: $id_empresa) {
    total_vacunados
    total_usuarios
    porcentaje_vacunados
    areas_estadisticas {
      nombre_area
      total_vacunados
      total_usuarios
      porcentaje_vacunados
    }
  }
}`;

export const GET_VACUNAS_USUARIO = gql `
query ListVacunasUsuario(
  $id_usuario: String!
  $id_empresa: String!
  ) {
  ListVacunasUsuario(id_empresa: $id_empresa, id_usuario: $id_usuario) {
    id_vacuna
    numero_dosis
    fecha_dosis
    fecha_siguiente_dosis
    url_imagen
    tipo_vacuna {
      id_tipo
      nombre
    }
  }
}`;

export const GET_TIPO_VACUNA = gql `
query ListTipoVacunas(
  $id_empresa: String!
)
{
  ListTipoVacunas(id_empresa: $id_empresa) 
  {
    id_tipo
    nombre
  }
}
`
export const GET_ENCUESTAS_COVID = gql `
query EncuestaCovid(
  $id_empresa: String!
){
  EncuestaCovid(id_empresa: $id_empresa) {
    id_encuesta
    nombre_encuesta
    preguntas {
      id_pregunta
      texto_pregunta
      alternativas {
        id_alternativa
        texto_alternativa
      }
    }
  }
}
`

/*-------- Menu secciones user ------*/
export const GET_MENU = gql `
query buscarMenu {
  buscarMenu {
    id_header
    nombre_header
    color_activo
    orden
    principal {
      id_elemento
      nombre_elemento
      orden
      url_externa
      secundarios {
        id_elemento
        nombre_elemento
        orden
        url_externa
        terciarios {
          id_elemento
          nombre_elemento
          orden
          url_externa
        }
      }
    }
  } 
} `;


/*-------- Beneficios ------*/
export const GET_TIPO_BENEFICIOS_EMPRESA = gql `
query TipoSolicitudes(
  $id_empresa: String!
) 
{
  TipoSolicitudes(id_empresa: $id_empresa) 
  {
    id_tipo,
    nombre_solicitud,
    url_imagen
  }
}`;
export const LISTAR_BENEFICIO = gql `
query ListarAllElementsTiposSolicitud(
  $id_empresa: String!
  $id_usuario: String!
  $id_tipo_solicitud: String!
) 
{
  ListarAllElementsTiposSolicitud(id_empresa: $id_empresa, id_usuario: $id_usuario, id_tipo_solicitud: $id_tipo_solicitud) {
    id_tipo,
    nombre_solicitud,
    descripcion,
    datos_formulario {
      id_formulario,
      nombre,
      is_admin,
      condicion,
      con_valor_predeterminado,
      tipo_dato,
      datos_selector_producto {
        id_inventario,
        nombre,
        con_limite,
        con_detalle,
        cantidad_actual,
        cantidad_inicial,
        limite_cantidad
      }
      datos_selector_empresa {
        id_dato_selector,
        nombre,
        descripcion,
        id_formulario_dato_fk
      },
      datos_selector_inventario {
        id_detalle,
        nombre_detalle,
        codigo_detalle,
        tipo_detalle
      }
      informacion_usuario
    },
    datos_inventario {
      id_inventario,
      nombre
    }
  }
}`;

export const LISTA_BENEFICIO_USUARIO = gql `
query ListSolicitudesUsuarios(
  $id_empresa: String!
  $id_usuario: String!
  $id_tipo_solicitud: String!
){
  ListSolicitudesUsuarios(id_empresa: $id_empresa, id_usuario: $id_usuario, id_tipo_solicitud: $id_tipo_solicitud) {
    id_solicitud,
    codigo_solicitud,
    descripcion,
    fecha_creacion,
    estado_solicitud {
      id_estado_solicitud,
      nombre,
      color
    }
    detalle_solicitud {
      id_solicitud_detalle,
      cantidad_solicitada,
      cantidad_entregada
    },
    tipo_solicitud {
      id_tipo,
      nombre_solicitud,
      descripcion,
      datos_formulario {
        id_formulario,
        nombre,
        is_admin,
        condicion,
        con_valor_predeterminado,
        tipo_dato,
        datos_selector_producto {
          id_inventario,
          nombre,
          con_limite,
          con_detalle,
          cantidad_actual,
          cantidad_inicial,
          limite_cantidad
        }
        datos_selector_empresa {
          id_dato_selector,
          nombre,
          descripcion
        },
        datos_selector_inventario {
          id_detalle,
          nombre_detalle,
          codigo_detalle,
          tipo_detalle
        }
        informacion_usuario
      },
    }
  }
}`;
/*-------- Beneficios ------*/

export const GET_LISTA_CHAT_INDIVIDUAL = gql `
  query listaChatIndividual($id_empresa: String!, $id_usuario: String!) {
    listaChats: listaChatIndividual(id_empresa_fk: $id_empresa, id_usuario: $id_usuario) {
      # fecha_creacion
      fecha_modificacion
      id_chat
      is_favorito
      usuarios {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          id_cargo
          nombre_cargo
        }
      }
      mensajes {
        id_chat_mensaje
        mensaje
        visto_mensaje
        fecha_creacion
        id_destinatario
        id_remitente
      }
    }
  }
`;

export const GET_LISTA_CHAT_GRUPAL = gql `
query listaChatGrupal($id_empresa: String!, $id_usuario: String!) {
  listaChats: listaChatGrupal(id_empresa_fk: $id_empresa, id_usuario: $id_usuario) {
    # fecha_creacion
    fecha_modificacion
    id_chat: id_grupo
    nombre_grupo
    url_img_grupo
    id_moderador_fk
    moderador {
      id_usuario
      primer_nombre
      apellido_paterno
    }
    usuarios {
      id_usuario
      primer_nombre
      apellido_paterno
    }    
    mensajes {
      id_chat_mensaje: id_chat_grupo_mensaje
      mensaje
      visto_mensaje: visto
      fecha_creacion
      remitente {
        id_usuario
        primer_nombre
        apellido_paterno
      }
    }
  }
}
`;

export const GET_LISTA_CONTACTOS = gql`
query contactos(
  $id_empresa: String!
  $nombre_buscar: String!
  $id_gerencia: String!
) {
  contactos(
    id_empresa: $id_empresa, 
    nombre_buscar: $nombre_buscar, 
    id_gerencia: $id_gerencia
  ) {
    id_usuario
    primer_nombre
    apellido_paterno
    imagen_perfil
    telefono_movil
    correo
    anexo
    cargo {
      nombre_cargo
    }
    gerencia {
      nombre_gerencia
    }
  }
}`;

/*-------- Notificaciones ------*/
export const GET_PAGINAS_NOTIFICACIONES = gql`
query PaginasNotificacionesApp(
  $id_empresa: String!
  $id_usuario: String!
  $limite: String!
) 
{
  paginadorNotificacionesApp(id_usuario: $id_usuario, id_empresa: $id_empresa, limite: $limite) {
    pagina,
    notificaciones
  }
}`;

export const GET_NOTIFICACIONES_PAGINADAS = gql`
query listarNotificaciones(
  $id_empresa: String!
  $id_usuario: String!
  $id_notificacion: [String]! 
) 
{
  listarNotificaciones(id_usuario: $id_usuario, id_empresa: $id_empresa, id_notificacion: $id_notificacion) {
    id_notificacion,
    titulo_notificacion,
    texto_notificacion,
    fecha_creacion,
    fecha_notificacion,
    push_enviado,
    id_empresa_fk,
    tipo_notificacion {
      id_tipo,
      nombre_tipo
    }
    id_modulo_fk,
    id_estado_fk,
    noticia {
      id_noticia,
      titulo_noticia,
      tipo_noticia {
        id_tipo,
        nombre_tipo
      },
      fecha_noticia
    }
    galeria {
      id_galeria,
      titulo_galeria,
      fecha_galeria
    }
    video {
      id_video,
      titulo_video,
      categoria {
        id_categoria,
        nombre_categoria
      },
      fecha_video
    }
    confirm_seen {
      id_usuario_fk
    }
  }
}`;
/*-------- Notificaciones ------*/
